import tealium from '../../tealium';
import { registerAnalyticsEventHandler } from '../registry';
import { IDataLayer } from '../../tealium/data_layer';

const defaultData: IDataLayer = {
  liveChatManualInitiated: {
    event_name: 'live_chat_user_initiated',
    event_category: 'live chat interaction',
    event_action: 'user initiated',
    event_label: null, // <page_name>
    event_value: '0',
    event_noninteraction: 'false',
    live_chat_initiation_type: 'user initiated'
  },

  liveChatManualPreSurvey: {
    event_name: 'live_chat_manual_prechat_survey',
    event_category: 'live chat interaction',
    event_action: 'prechat survey',
    event_label: 'shown',
    live_chat_initiation_type: 'user initiated'
  },

  liveChatManualWaiting: {
    event_name: 'live_chat_manual_prechat_accepted',
    event_category: 'live chat interaction',
    event_action: 'prechat survey',
    event_label: 'accepted',
    live_chat_initiation_type: 'user initiated',
    live_chat_type: 'order assistance'
  },

  liveChatManualChatting: {
    event_name: 'live_chat_manual_chatting',
    event_category: 'live chat interaction',
    event_action: 'chat start',
    event_label: 'order assistance',
    live_chat_initiation_type: 'user initiated',
    live_chat_type: 'order assistance'
  },

  liveChatProactiveDisplayed: {
    event_name: 'live_chat_proactive_shown',
    event_category: 'live chat interaction',
    event_action: 'proactive chat',
    event_label: 'shown',
    event_value: '0',
    event_noninteraction: 'false'
  },

  liveChatProactiveInitiated: {
    event_name: 'live_chat_proactive_accepted',
    event_category: 'live chat interaction',
    event_action: 'proactive chat',
    event_label: 'accepted',
    event_value: '0',
    event_noninteraction: 'false',
    live_chat_initiation_type: 'proactive'
  },

  liveChatProactivePreSurvey: {
    event_name: 'live_chat_proactive_prechat_survey',
    event_category: 'live chat interaction',
    event_label: 'shown',
    event_action: 'prechat survey',
    live_chat: 'Pre Survey Chat',
    live_chat_initiation_type: 'proactive'
  },

  liveChatProactiveWaiting: {
    event_name: 'live_chat_proactive_prechat_accepted',
    event_category: 'live chat interaction',
    event_action: 'prechat survey',
    event_label: 'accepted',
    live_chat_initiation_type: 'proactive',
    live_chat_type: 'order assistance'
  },

  liveChatProactiveChatting: {
    event_name: 'live_chat_proactive_chatting',
    event_category: 'live chat interaction',
    event_action: 'chat start',
    event_label: 'order assistance',
    live_chat_initiation_type: 'proactive',
    live_chat_type: 'order assistance'
  }
};

function trackLiveChat(eventName: string, eventData: IDataLayer = {}) {
  if (eventName.match(/Initiated/)) {
    eventData.event_label = tealium.dataLayer?.data?.page_name || '';
  }

  tealium.evtLink({ ...defaultData[eventName], ...eventData });
}

Object.keys(defaultData).forEach((key) => {
  registerAnalyticsEventHandler(key, trackLiveChat);
});
